import { computed as l, createElementBlock as r, openBlock as d, normalizeClass as a, createElementVNode as i, Fragment as h, createBlock as g, createCommentVNode as m, unref as u, renderSlot as _ } from "vue";
import { themeProp as w } from "../../composables/useTheme.js";
import { screenProp as f, isScreenLarge as v, isScreenMedium as y } from "../../utils/utilsScreen.js";
/* empty css                         */
import k from "../../atoms/image-element/image-element.vue.js";
const p = ["src", "alt"], j = {
  key: 2,
  class: "ds-header-with-divider__divider-wrapper ds-header-with-divider__divider-wrapper--sticky-bottom",
  "data-j-divider": ""
}, b = { class: "ds-grid ds-justify-content-center" }, B = {
  key: 0,
  class: "ds-header-with-divider__divider-wrapper",
  "data-j-divider": ""
}, N = /* @__PURE__ */ Object.assign({
  name: "DsHeaderWithDivider"
}, {
  __name: "header-with-divider",
  props: {
    ...w,
    ...f,
    image: {
      type: Object,
      default: null
    },
    columns: {
      type: Number,
      default: 10,
      validator: (e) => e === 10 || e === 12
    },
    // To display the header inside a ds-container
    contained: {
      type: Boolean,
      default: !1
    },
    breakpoint: {
      type: String,
      default: "large"
    }
  },
  setup(e) {
    const t = e, n = l(() => t.breakpoint === "medium" ? v(t.screen) || y(t.screen) : v(t.screen)), c = l(() => !!t.image.original);
    return (s, o) => (d(), r("div", {
      class: a({ "ds-container": e.contained })
    }, [
      i("div", {
        class: a(["ds-header-with-divider", [
          { "ds-header-with-divider--with-fixed-height": e.image && !c.value },
          `ds-header-with-divider--${s.theme}`
        ]])
      }, [
        e.image ? (d(), r(h, { key: 0 }, [
          c.value ? (d(), g(u(k), {
            key: 0,
            class: "ds-header-with-divider__image",
            screen: s.screen,
            image: e.image
          }, null, 8, ["screen", "image"])) : (d(), r("img", {
            key: 1,
            class: "ds-header-with-divider__image",
            src: e.image.src,
            alt: e.image.name
          }, null, 8, p)),
          n.value ? (d(), r("div", j, [
            i("div", {
              class: a(["ds-header-with-divider__divider-wrapper__container", { "ds-grid": e.contained, "ds-container": !e.contained }])
            }, [
              i("div", {
                class: a(["ds-header-with-divider__divider", { "ds-grid__col ds-grid__col--offset-1 ds-grid__col--10": e.contained }])
              }, null, 2)
            ], 2)
          ])) : m("", !0)
        ], 64)) : (d(), r("div", {
          key: 1,
          class: a({ "ds-container": !e.contained }),
          "data-j-header-content": ""
        }, [
          i("div", b, [
            i("div", {
              class: a(["ds-grid__col ds-grid__col--12 ds-padding-y-48 ds-md-padding-y-96", `ds-lg-grid__col--${e.columns}`])
            }, [
              _(s.$slots, "headerContent")
            ], 2)
          ]),
          n.value ? (d(), r("div", B, o[0] || (o[0] = [
            i("div", { class: "ds-header-with-divider__divider-wrapper__container" }, [
              i("div", { class: "ds-header-with-divider__divider ds-grid" })
            ], -1)
          ]))) : m("", !0)
        ], 2))
      ], 2)
    ], 2));
  }
});
export {
  N as default
};
